/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const SHIELD_VIEWBOX = 28;

const SHIELD_OUTLINE_PATH =
  'M14.0001 3.5L23.3334 7V14C23.3334 19.8333 19.2501 23.9167 14.0001 24.5C8.75008 23.9167 4.66675 19.8333 4.66675 14V7L14.0001 3.5V3.5';

const SHIELD_CHECK_PATH = 'M10.5 14.0001L12.8333 16.3334L17.5 11.6667';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Shield with checkmark (28×28). Color via `stroke` or CSS `color` + `currentColor`.
 * Pass `aria-label` when the icon conveys meaning without adjacent text.
 */
const ShieldIcon = ({
  size = 28,
  stroke = 'currentColor',
  strokeWidth = 2.1,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${SHIELD_VIEWBOX} ${SHIELD_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d={SHIELD_OUTLINE_PATH}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d={SHIELD_CHECK_PATH}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

ShieldIcon.propTypes = {
  ...iconPropTypes,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

export { ShieldIcon };
export default ShieldIcon;
